<template>
  <div class="feedback">
    <md-progress-spinner
      :md-diameter="30"
      :md-stroke="3"
      md-mode="indeterminate"
      v-if="!sortedFeedback"
    ></md-progress-spinner>
    <div v-for="item in sortedFeedback" v-bind:key="item.timestamp" v-else>
      <md-card md-dense>
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">
              {{ item.study ? item.study : "Anonymous" }}
            </div>
            <div class="md-subhead">{{ item.timestamp | moment("from") }}</div>
          </md-card-header-text>

          <md-menu md-size="big" md-direction="bottom-end">
            <md-chip class="version-nb"
              >Version <strong>{{ item.version }}</strong></md-chip
            >
            <md-button
              class="md-icon-button md-primary"
              @click="archive(item.id)"
              v-if="userRole === 'admin'"
            >
              <md-icon>archive</md-icon>
            </md-button>
          </md-menu>
        </md-card-header>

        <md-card-content>
          {{ item.feedback }}
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<style scoped>
.feedback {
  text-align: center;
}
.feedback .md-card {
  width: 100%;
  max-width: 600px;
  display: inline-block;
  vertical-align: top;
  margin: 5px 0px;
  text-align: left;
}
.caption {
  color: #999;
}

.version-nb {
  margin-right: 10px;
  margin-top: 4px;
}
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "feedback",
  computed: {
    ...mapState(["dbFeedback", "userRole"]),
    sortedFeedback() {
      let sorted = [];
      for (let key in this.dbFeedback) {
        let item = this.dbFeedback[key];
        item.id = key;
        sorted.unshift(item);
      }
      return sorted.sort((a, b) => a.timestamp - b.timestamp);
    }
  },
  methods: {
    archive(itemId) {
      this.$store.dispatch("archiveFeedback", itemId);
    }
  },
  created() {
    this.$store.dispatch("fetchFeedback");
  }
};
</script>
